import * as React from "react";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { CodeIcon, PencilIcon, DotsVerticalIcon, LocationMarkerIcon, ViewListIcon } from "@heroicons/react/solid";
import InputMask from "react-input-mask";
import NeatcarButton from "../../components/NeatcarButton";
import Paginator from "../../components/Paginator";
import TransactionRow from "../../components/TransactionRow";
import LoadingIndicator from "../../components/LoadingIndicator";
//import visa from '../../assets/images/visa.png';
//import mastercard from '../../assets/images/mastercard.png';
import { getCurrentCard, setCreditCardLoading } from "../../store/actions/Business";
import { updateCard } from "../../services/business";
import { pushNotification } from "../../store/actions/Notifications";
import { ERROR, Notification, SUCCESS } from "../../models/Notification";
import { getCSV } from "../../services/transactions";
import fileDownload from 'js-file-download';
import { StationsTable } from "../../table/station/StationsTable"
import { Store, columns } from "../../table/station/columns"
import { Tabs, TabsList, TabsTrigger, TabsContent } from "components/ui/tabs";
import Map from 'react-map-gl/mapbox';
import 'mapbox-gl/dist/mapbox-gl.css';



import { getStoresData, getRemainingCarwashData, getCarwashTypeData } from 'store/actions/Support';

const Stations = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [page, setPage] = useState(1);
  const [csvLoading, setCsvLoading] = useState(false);
  const { t } = useTranslation(['billing', 'transaction']);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const stores = useSelector(store => store.support);
  const [tableData, setTableData] = useState([]);
  const mapRef = useRef(null);
  const [activeTab, setActiveTab] = useState("map");


  const [data, setData] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const fetchedData = await getData();
      setData(fetchedData);
      console.log(data)
    }
    fetchData();
  }, []);

  useEffect(() => {

    dispatch(getStoresData());
 

  }, [dispatch, navigate, page]);

 

  useEffect(() => {
    
    if (stores && stores.storesLoading == false) {
      setTableData(stores.stores)
    }
 
   }, [stores]);

  useEffect(() => {
    dispatch(getCurrentCard());
  }, [dispatch]);

  const onSubmit = (data) => {
    dispatch(setCreditCardLoading(true));
    updateCard({
      name: data.name,
      number: data.cardNumber.replace(/\s/g, ''),
      exp_month: data.expirationDate.substring(0, 2),
      exp_year: `20${data.expirationDate.substring(3, 5)}`,
      cvv: data.cvv
    }).subscribe({
      next: () => {
        dispatch(getCurrentCard());
        dispatch(pushNotification(new Notification(SUCCESS, t('billing:modifiedCreditCardSuccessTitle'), t('billing:modifiedCreditCardSuccessMessage'))));
      },
      error: (err) => {
        dispatch(setCreditCardLoading(false));
        dispatch(pushNotification(new Notification(ERROR, t('billing:modifiedCreditCardErrorTitle'), t('billing:modifiedCreditCardErrorMessage'))));
      }
    });
  }

  async function getData() {
    // Fetch data from your API here.
    return [
      {
        id: '728ed52f',
        amount: 100,
        status: 'pending',
        email: 'm@example.com',
      },
      // ...
    ];
  }
 
  // helper to trigger a map resize (works across different react-map-gl versions)
  const ensureMapResize = (delay = 180) => {
    setTimeout(() => {
      try {
        if (mapRef.current?.getMap) { // react-map-gl v8
          mapRef.current.getMap().resize();
          return;
        }
        if (typeof mapRef.current?.resize === "function") { // older API
          mapRef.current.resize();
          return;
        }
      } catch (e) { /* ignore */ }
      // fallback: force browser resize event
      window.dispatchEvent(new Event("resize"));
    }, delay);
  };

  useEffect(() => { ensureMapResize(300); }, []);

  return (
    // ensure the page/container has height so flex-1 children can grow
    <div className="flex-1 flex flex-col gap-x-8 min-h-screen">
      <Tabs defaultValue="map" className="w-full" onValueChange={(v) => { setActiveTab(v); if (v === "map") ensureMapResize(220); }}>
        {/* shrink to content: inline-flex + w-max */}
        <div className="w-full flex"> {/* optional container to control alignment */}
          <TabsList className="inline-flex flex-wrap items-center gap-2 w-max">
            <TabsTrigger
              value="stations"
            >
              <ViewListIcon className="w-5 h-5" />
              <span className="whitespace-nowrap">Table</span>
            </TabsTrigger>
            <TabsTrigger
              value="map"
            >
              <LocationMarkerIcon className="w-5 h-5" />
              <span className="whitespace-nowrap">Map</span>
            </TabsTrigger>
          </TabsList>
        </div>
 
        <TabsContent value="map" className="">
          {/* use an inline height to guarantee non-zero computed height */}
          <div className="w-full" style={{ height: 400, minHeight: 300 }}>
            <Map
              ref={mapRef}
              mapboxAccessToken="pk.eyJ1IjoieW9hbnBvdWxpbiIsImEiOiJjbWdic2R6NHgwdWo2MmxvajNuNmIzbWQ2In0.dnbekXHo5480u_u7ED24RQ"
              initialViewState={{
                longitude: -122.4,
                latitude: 37.8,
                zoom: 14
              }}
              style={{ width: "100%", height: "100%" }}
              mapStyle="mapbox://styles/mapbox/streets-v9"
              onLoad={() => ensureMapResize(120)}
            />
          </div>
        </TabsContent>
 
        <TabsContent value="stations" className="">
          <StationsTable columns={columns} data={tableData} />
        </TabsContent>
      </Tabs>
    </div>
  )
};

export default Stations;
